{
    "Accessibility menu": "Tillgänglighetsmeny",
    "Close": "Stäng",
    "Content adjustments": "Anpassa innehåll",
    "Navigation adjustments": "Anpassa navigering",
    "Text Align": "Textjustering",
    "Align Left": "Vänsterjustera",
    "Align Center": "Centrera",
    "Align Right": "Högerjustera",
    "Adjust Font Size": "Justera textstorlek",
    "Highlight Title": "Framhäv titel",
    "Highlight Links": "Framhäv länkar",
    "Readable Font": "Läsbart teckensnitt",
    "Colour adjustments": "Anpassa färger",
    "Dark Contrast": "Mörk kontrast",
    "Light Contrast": "Ljus kontrast",
    "High Contrast": "Hög kontrast",
    "High Saturation": "Hög mättnad",
    "Low Saturation": "Låg mättnad",
    "Monochrome": "Monokrom",
    "Tools": "Verktyg",
    "Reading Guide": "Läslinjal",
    "Big Cursor": "Stor muspekare",
    "Increase Font Size": "Öka textstorlek",
    "Decrease Font Size": "Minska textstorlek",
    "Letter Spacing": "Teckenavstånd",
    "Line Height": "Radhöjd",
    "Font Weight": "Teckentjocklek",
    "Dyslexia Font": "Teckensnitt för dyslexi",
    "Language": "Språk",
    "Accessibility widget": "Öppna tillgänglighetsmeny",
    "Accessibility Profiles": "Tillgänglighetsprofiler",
    "Cognitive Disability": "Kognitiv funktionsnedsättning",
    "Seizure Safe": "Anfallssäker",
    "Accessibility statement": "Tillgänglighetsredogörelse",
    "ADHD": "ADHD",
    "Low Vision": "Nedsatt syn",
    "Pause Animations": "Pausa animationer",
    "Animation paused": "Animering pausad",
    "Reset all settings": "Nollställ inställningar",
    "Shortcut:": "Genväg:",
    "Epilepsy Safe Mode": "Epilepsisäkert läge",
    "Mute sounds": "Stäng av ljud",
    "Page read": "Läs upp sidan",
    "Page read controls": "Uppläsningskontroller",
    "Pause": "Pausa",
    "Resume": "Återuppta",
    "Stop": "Stoppa",
    "Settings": "Inställningar",
    "Speed": "Hastighet",
    "Voice": "Röst",
    "Close accessibility menu": "Stäng tillgänglighetsmeny",
    "Back to accessibility menu": "Tillbaka till tillgänglighetsmeny",
    "Search languages": "Sök språk",
    "Selected language": "Valt språk",
    "View accessibility statement (opens in new window)": "Visa tillgänglighetsredogörelse (öppnas i nytt fönster)",
    "Visit CookieYes website (opens in new window)": "Besök CookieYes webbplats (öppnas i nytt fönster)",
    "Reset all accessibility settings to default": "Återställ alla tillgänglighetsinställningar"
}
